// Light 클래스와 관련 타입, 설정, 유틸리티 함수 통합 export
export { default as Light } from './light';
export {
  createDirectionalLight,
  createHemisphereLight,
  createPointLight,
  createAmbientLight,
  createLightFromConfig
} from './core';
export type {
  Position,
  ShadowConfig,
  DirectionalLightConfig,
  HemisphereLightConfig,
  PointLightConfig,
  AmbientLightConfig,
  LightConfigType,
  EnvironmentConfig,
  LightingConfig
} from './type'; 